window.Form = function(data) {
    let form = this;

    this.data = {};

    $.extend(this, data);

    this.alert = null;
    this.working = false;
    this.originalData = { ...this.data };

    // Process the form
    this.startProcessing = function() {
        form.alert = null;
        form.working = true;
    };

    // Finish processing the form
    this.finishProcessing = function() {
        form.working = false;
    };

    //Set the alerts on the form
    this.setAlert = function(type, message, errors) {
        form.alert = {
            type: type,
            message: message,
            errors: errors !== undefined ? errors : null
        };
    };

    this.resetAlert = function () {
        this.alert = null;
    };

    this.resetForm = function() {
        this.data = { ...this.originalData };

        Bus.$emit('clearForm');
    };
};
